const RevenueAgencyListTableLangKey = [
	'column_id',
	'column_name',
	'column_date_updated',
	'column_group',
	'column_percent',
	'column_is_system',
	'column_is_active',
	'column_is_hold',
	'column_fake_type',
	'column_history',
	'column_notes'
] as const

type IRevenueAgencyListTableLangKey = typeof RevenueAgencyListTableLangKey[number]

export type IRevenueAgencyListTableLang = {
	revenue_agency_list_table: Record<IRevenueAgencyListTableLangKey, string>
}

const langEntries = RevenueAgencyListTableLangKey.map(
	(key: IRevenueAgencyListTableLangKey) => [key, `revenue_agency_list_table.${key}`]
)

const langObj: Record<IRevenueAgencyListTableLangKey, string> = Object.fromEntries(langEntries)

export const REVENUE_AGENCY_LIST_TABLE_LANG_KEY: IRevenueAgencyListTableLang = {
	revenue_agency_list_table: langObj
}
